<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    :title="$l('dialog_title_change_customer_information')"
    width="1100px"
    top="10vh"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    append-to-body
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :custCode="custCode"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('form_submit_application') || '提交申请' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    custCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
